export const setContractPdfUrl = (state, action) => {
  state[action?.payload?.contractid] = {
    ...state[action?.payload?.contractid],
    contractUrl: action?.payload?.contracturl,
  };
  return state;
};
export const setDisclosurePdfUrl = (state, action) => {
  state[action?.payload?.contractid] = {
    ...state[action?.payload?.contractid],
    disclosureUrl: action?.payload?.disclosureUrl,
  };
  return state;
};
export const setMMLISAddOnPdfUrl = (state, action) => {
  state[action?.payload?.contractid] = {
    ...state[action?.payload?.contractid],
    mmlisAddOnUrl: action?.payload?.mmlisAddOnUrl,
  };
  return state;
};
export const setIAAddOnPdfUrl = (state, action) => {
  state[action?.payload?.contractid] = {
    ...state[action?.payload?.contractid],
    iaAddOnUrl: action?.payload?.iaAddOnUrl,
  };
  return state;
};
export const setHistoricalConfPdfUrl = (state, action) => {
  state[action?.payload?.contractid] = {
    ...state[action?.payload?.contractid],
    historicalConfUrl: action?.payload?.historicalConfUrl,
  };
  return state;
};
export const setAddOnStatuses = (state, action) => {
  state[action?.payload?.contractid] = {
    ...state[action?.payload?.contractid],
    addOnStatuses: action?.payload?.addOnStatuses,
  };
  return state;
};
